import type { components } from '../../api/generated/schema';
import type {
  Conversation,
  ConversationSummary,
  Message,
  MessagePhoto,
  MessagePhotoUpload,
  NewMessage,
} from '../../domain/conversations';
import { toPersonRef } from '../mapping';

type S = components['schemas'];

export function toConversationSummary(c: S['ConversationSummary']): ConversationSummary {
  return {
    id: c.id,
    kind: c.kind,
    name: c.name,
    otherPeople: c.other_people.map(toPersonRef),
    listing: c.listing ? { id: c.listing.id, title: c.listing.title } : null,
    lastMessagePreview: c.last_message_preview,
    lastMessageAt: c.last_message_at,
    hasUnread: c.has_unread,
    canSend: c.can_send,
  };
}

export function toMessagePhoto(p: S['MessagePhoto']): MessagePhoto {
  return { id: p.id, url: p.url, width: p.width, height: p.height, mimeType: p.mime_type };
}

export function toMessage(m: S['Message']): Message {
  return {
    id: m.id,
    kind: m.kind,
    sender: m.sender ? toPersonRef(m.sender) : null,
    body: m.body,
    photos: m.photos.map(toMessagePhoto),
    sentAt: m.sent_at,
    removed: m.removed,
    isCollapsed: m.is_collapsed,
  };
}

export function toConversation(c: S['ConversationDetail']): Conversation {
  return {
    ...toConversationSummary(c),
    messages: c.messages.map(toMessage),
    canAddPeople: c.can_add_people,
    canRename: c.can_rename,
    canRemovePeople: c.can_remove_people,
    canLeave: c.can_leave,
  };
}

export function toNewMessage(m: NewMessage): S['MessageCreateRequest'] {
  return {
    ...(m.body !== null && { body: m.body }),
    photo_ids: m.photoIds,
    idempotency_key: m.idempotencyKey,
  };
}

/** The request-upload answer is untyped in the contract; these are the keys it sends. */
export function toMessagePhotoUpload(body: Record<string, unknown>): MessagePhotoUpload {
  return {
    imageId: String(body.image_id ?? ''),
    blobName: String(body.blob_name ?? ''),
    uploadUrl: String(body.upload_url ?? ''),
  };
}
